// components
import type { BoxProps } from '@mui/material';
import { styled, Box, alpha } from '@mui/material';

export const StyledChangesAfterPublicationPlaceholderBox = styled(
  Box
)<BoxProps>(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  textAlign: 'center',
  backgroundColor: alpha(theme.palette.primary.main, 0.06),
  borderRadius: theme.shape.borderRadius,
  border: `1px dashed ${alpha(theme.palette.primary.main, 0.2)}`
}));
